import { render, staticRenderFns } from "./StockProcessingOrderItems.vue?vue&type=template&id=39c9ca39&scoped=true&"
import script from "./StockProcessingOrderItems.vue?vue&type=script&lang=js&"
export * from "./StockProcessingOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./StockProcessingOrderItems.vue?vue&type=style&index=0&id=39c9ca39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9ca39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VOverlay,VProgressCircular,VSelect,VSkeletonLoader,VTextField})
